import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import ErrorIcon from '@mui/icons-material/Error';
import { useTranslation } from 'react-i18next'

interface UnsavedChangesDialogProps {
    open: boolean
    onDiscard: () => void
    onCancel: () => void
}

const UnsavedChangesDialog = ({ open, onDiscard, onCancel }: UnsavedChangesDialogProps) => {
    const { t } = useTranslation('common')

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs">
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ErrorIcon sx={{ color: '#F59E1B' }} />
                {t('unsaved.changes')}
            </DialogTitle>
            <DialogContent>
                {t('unsaved.changes.content')}
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onDiscard}>{t('discard.changes')}</Button>
                <Button variant="contained" onClick={onCancel}>
                    {t('go.back.to.edit')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default UnsavedChangesDialog